@if (config) {
  <div class="container">
    @for (row of rows; track row) {
      <section
        [ngStyle]="{ 'margin-bottom': row.marginBottom }"
        class="grid__row"
      >
        @for (col of row.columns; track col) {
          <div class="grid__column">
            @for (line of col.lines; track line) {
              @switch (line.type) {
                <!-- Image column line -->
                @case (types.image) {
                  @if (line.route) {
                    <a [attr.href]="line.route" target="_blank">
                      <img
                        class="column__line--image"
                        [attr.title]="line.title"
                        [src]="line.source"
                        [ngStyle]="{
                          width: line.width,
                          height: line.height,
                        }"
                      />
                      <img
                        class="column__line--image--mobile"
                        [attr.title]="line.title"
                        [src]="line.source"
                      />
                    </a>
                  } @else {
                    <img
                      class="column__line--image--mobile"
                      [attr.title]="line.title"
                      [src]="line.source"
                    />
                    <img
                      class="column__line--image"
                      [attr.title]="line.title"
                      [src]="line.source"
                      [ngStyle]="{
                        width: line.width,
                        height: line.height,
                      }"
                    />
                  }
                }
                @case (types.header) {
                  <div class="column__line--header">
                    <h4>{{ line.label }}</h4>
                  </div>
                }
                <!-- column long text/paragraph line -->
                @case (types.longText) {
                  <div class="column__line__paragraphs">
                    @for (paragraph of line.paragraphs; track paragraph) {
                      <p class="t-data" [innerHTML]="paragraph.text"></p>
                    }
                  </div>
                }
                @case (types.button) {
                  <div class="column__line__button">
                    <zip-button
                      [config]="line.config"
                      (zipButtonClicked)="buttonClick(line)"
                    ></zip-button>
                  </div>
                }
                @case (types.link) {
                  <div class="column__line">
                    <a
                      class="t-data t-bold t-link"
                      [attr.href]="line.route"
                      target="_blank"
                      [innerHTML]="line.label"
                    ></a>
                  </div>
                }
              }
            }
          </div>
        }
      </section>
    }
  </div>
}
